var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"neo__loading"},_vm._l((parseInt(12)),function(index){return _c('div',{key:`load__${index}`})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }